import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    description: {
      marginBottom: theme.spacing(2),
    },
    fieldLayout: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    successMessage: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
  };
};
